export const contact = {
  contactType: '',
  label: '',
  value: '',
  error: '',
  isActive: true,
  isPrimary: false,
};

export const phoneTypes = Object.freeze([
  { label: 'Mobile', value: 'mobile' },
  { label: 'Landline', value: 'landline' },
]);

export const newSupplier = {
  name: '',
  supplierName: '',
  notes: '',
  accPayableTerm: {},
  type: {
    label: 'Internal',
    name: 'Internal',
    value: 'internal',
    icon: 'far fa-user',
    placeholder: 'Internal',
  },
  accountNumber: '',
  internalSupplierReference: null,
  url: '',
  isActive: true,
  billingAddress: {
    addLine1: '',
    addLine2: '',
    city: '',
    state: '',
    zip: '',
    country: '',
    stateCode: '',
  },
  wareHouseAddress: {
    addLine1: '',
    addLine2: '',
    city: '',
    state: '',
    zip: '',
    country: '',
    stateCode: '',
  },
  emails: [
    {
      ...contact,
      isPrimary: true,
      contactType: { label: 'Email', value: 'email' },
    },
  ],
  phones: [
    {
      ...contact,
      isPrimary: true,
      contactType: { label: 'Mobile', value: 'mobile' },
    },
  ],
  tags: [],
};
